//
//EwSiteApp.requires.push('flow');
//EwSiteApp.requires.push('ui.bootstrap');

'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.requires.push('bgf.paginateAnything');
//function modalRejectHandler(result){
//	console.log(result);
//}

//EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
//		flowFactoryProvider.defaults = {
//			target: '',
//			permanentErrors: [202, 404, 500, 501],
//			maxChunkRetries: 1,
//			chunkRetryInterval: 5000,
//			simultaneousUploads: 1,
//			singleFile: false,
//			chunkSize: 2 * 1024 * 1024,
//			forceChunkSize: true
//		};
//		// Add XSRF header to upload requests
//		if (typeof (secure_xsrf_name) != 'undefined') {
//			var xsrf_token = getJsCookieValue(secure_xsrf_name);
//			if (xsrf_token !== '') {
//				flowFactoryProvider.defaults.headers = {};
//				flowFactoryProvider.defaults.headers['X-' + secure_xsrf_name] = xsrf_token;
//			}
//		}
//		flowFactoryProvider.on('fileSuccess', function (file, response) {
//			try {
//				eval("var d = " + response);
//				if (typeof (d.success) !== 'undefined') {
//					file.response = d;
//				}
//			} catch (err) {
//				console.error('Network Error: bad response format - ' + err.message);
//			}
//		});
////	flowFactoryProvider.on('catchAll', function (event) {
////	 console.log('catchAll', arguments);
////	 });
//
////	 flowFactoryProvider.on('fileAdded', function (event) {
////	 console.log(event);
////	 });
//		// Can be used with different implementations of Flow.js
//		// flowFactoryProvider.factory = fustyFlowFactory;
//	}]);

EwSiteApp.controller('SingleFile',['$scope', '$filter', '$log', '$http', function($scope, $filter, $log, $http){
	$scope.uploaded_file = 0;
	$scope.errors = [];
	$scope.hasError = false;
	$scope.max_file_size = 0;
	$scope.closeAlert = function (index) {
		$scope.errors.splice(index, 1);
	};

	$scope.transmitToParent = function(name, val){
		if (typeof ($scope.$parent.postData[name]) !== 'undefined') {
			$scope.$parent.postData[name] = val;
		}
	};

	$scope.onFileAdded = function ($file, extensions) {
		var output = false;
		if($scope.max_file_size>0 && $file.size>$scope.max_file_size){
			$scope.hasError = true;
			$scope.errors.push($file.name+' - File too large');
			return output;
		}
		if (typeof(extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1){
			output = true;
		}
		if (!output){
			$scope.hasError = true;
			$scope.errors.push($file.name+' '+$scope.error_msg);
		}
		return output;
	};

	function flowErrors ($file){
		if(typeof ($file.response) !== 'undefined'){
			if(typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId>0 && $file.response.success){
				return true;
			}
			else if(typeof ($file.response.message) !== 'undefined'){
				$scope.hasError = true;
				$scope.errors.push($file.name+' - '+$file.response.message);
				return false;
			}
		}
		else{
			$scope.hasError = true;
			$scope.errors.push($file.name+' - Server error');
			return false;
		}
		return null;
	}

	$scope.onFileSuccess = function ($file, $message, flowFile, name) {
		let flow_errors = flowErrors($file);
		if(true === flow_errors){
			$scope.transmitToParent(name, $file.response.fileId);
		}
		else if(false === flow_errors){
			flowFile.cancel();
		}
	};

	$scope.onFileError = function ($file, $message, flowFile ) {
		if(false === flowErrors($file)){
			flowFile.cancel();
			$scope.transmitToParent(name, 0);
		}
	};


	$scope.removeUploaded = function(file, name){
		$scope.transmitToParent(name, 0);

		file.cancel();
	};

}]);

EwSiteApp.controller('MultiUploadNaturaltest',['$scope', '$filter', '$log', '$attrs', function ($scope, $filter, $log, $attrs) {
	$scope.files = [];
	$scope.fileids = [];
	$scope.errors = [];
	$scope.hasError = false;
	$scope.closeAlert = function (index) {
		$scope.errors.splice(index, 1);
	};

	$scope.transmitToParent = function () {
		if (typeof ($scope.$parent.postData.files) !== 'undefined') {
			$scope.$parent.postData.files = $scope.fileids;
		}
	};

	$scope.onFileAdded = function ($file, extensions) {
		var output = false;
		if (typeof (extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1) {
			output = true;
		}
		if (!output) {
			$scope.hasError = true;
			$scope.errors.push($file.name + ' ' + $attrs.errorMsg);
		}
		return output;
	};

	function flowErrors($file) {
		if (typeof ($file.response) !== 'undefined') {
			if (typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId > 0 && $file.response.success) {
				return true;
			} else if (typeof ($file.response.message) !== 'undefined') {
				$scope.hasError = true;
				$scope.errors.push($file.name + ' - ' + $file.response.message);
				return false;
			}
		} else {
			$scope.hasError = true;
			$scope.errors.push($file.name + ' - Server error');
			return false;
		}
		return null;
	}

	$scope.onFileSuccess = function ($file, $message, flowFile) {
		let flow_errors = flowErrors($file);
		if(true === flow_errors){
			$scope.fileids.push($file.response.fileId);
			$scope.transmitToParent();
		}
		else if(false === flow_errors){
			flowFile.cancel();
		}
	};

	$scope.onFileError = function ($file, $message, flowFile) {
		if (false === flowErrors($file)) {
			flowFile.cancel();
		}
	};

	$scope.removeUploaded = function(file){
		file.cancel();
		var indx = $scope.fileids.indexOf(file.response.fileId);
		if (indx > -1) {
			$scope.fileids.splice(indx, 1);
		}

		$scope.transmitToParent();

	};

}]);

EwSiteApp.controller('NaturaltestFormCtrl',['$scope', '$http', '$filter', '$uibModal', '$log', '$sce', '$interval', '$timeout', 'ajaxSearch', 'SessionService',function ($scope, $http, $filter, $uibModal, $log, $sce, $interval, $timeout, ajaxSearch, SessionService) {
	$scope.uploads_count = 0;
	$scope.vertCheckUrl = naturaltestData.vertCheckUrl;
	$scope.formUrl = naturaltestData.formUrl;
	$scope.postUrl = naturaltestData.postUrl;
	$scope.vertNrValid  = false;
	$scope.vert_document_nr = '';
	$scope.vert_application_term_nr = '';
	$scope.vert_term_tests_date = '';
	$scope.showFormInputFields = false;
	$scope.loading = false;
	$scope.submited = false;

	$scope.addresses = [];
	$scope.showSuggest = false;
	$scope.findUrl = naturaltestData.findUrl;
	$scope.addressLoading = false;
	$scope.contractor_phone = '';

	$scope.postData = {
		municipality_id: '',
		address: '',
		address_id: null,
		power_level: '',
		vert_application_term_nr: '',
		vert_document_nr: '',
		requested_date: '',
		contractor_email: '',
		contractor_phone: '',
		transformatory_nr: '',
		toc: false,
		report_file: 0,
		protocol_file: 0,
		program_file: 0,
		raa_file: 0,
		files: []
	};

		$scope.$watch("contractor_phone", function (newVal) {
			if (newVal) {
				$scope.postData.contractor_phone = '+370' + newVal;
			} else {
				$scope.postData.contractor_phone = '';
			}
		});

	$scope.formValid = function(){
		return (parseInt($scope.postData.report_file)>0 && parseInt($scope.postData.protocol_file)>0 && parseInt($scope.postData.program_file)>0);
	};

	$scope.checkVertNr = function(){
		$scope.checking_nr = true;
		if($scope.vertCheckUrl !== ''){
			$scope.vertNrValid = false;
			$http({
				method: 'POST',
				url: $scope.vertCheckUrl,
				data: {
					vert_application_term_nr: $scope.vert_application_term_nr,
					vert_document_nr: $scope.vert_document_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function(response){
				if(response.data.success) {
					$scope.vertNrValid = true;
					$scope.postForm();
				}
				else {
					$scope.error_message = response.data.message;
				}
			}, function(response){
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;
			});
		}
	};

	$scope.formInvalid = function(){
		return (!$scope.vert_application_term_nr || !$scope.vert_document_nr);
	};

	$scope.$watch("vert_application_term_nr", function (newVal, oldVal) {
		if (typeof newVal !== 'undefined') {
			newVal = newVal.replace(/[^0-9a-z]/ig, '').substring(0, 7).replace(/^(0[0-9]|10|11|12|13)/, '').replace(/^(.{2})(.+)$/i, '$1-$2');
			$scope.vert_application_term_nr = newVal;
		}
	});


	$scope.postForm = function () {
		if($scope.formUrl !== ''){
			$http({
				method: 'POST',
				url: $scope.formUrl,
				data: {
					vert_application_term_nr: $scope.vert_application_term_nr,
					vert_document_nr: $scope.vert_document_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function(response){
				if(response.data.success) {
					$scope.showFormInputFields = true;
					$scope.vert_term_tests_date = response.data.data.vert_term_tests_date;
					$scope.postData.vert_application_term_nr = response.data.data.vert_application_term_nr;
					$scope.postData.vert_document_nr = response.data.data.vert_document_nr;
				}
				else {
					$scope.error_message = response.data.message;
				}
			}, function(response){
				console.log(['Error', response]);
			}).then(function () {

			});
		}
	};

	$scope.submitForm = function () {
		$scope.trySubmit = true;
		if ($scope.postUrl && $scope.postUrl !== '') {
			$scope.loading = true;
			if(typeof naturaltestData.recaptcha !== 'undefined'){
				grecaptcha.ready(function() {
					grecaptcha.execute(naturaltestData.recaptcha.siteKey, {action: 'submit'}).then(function(token){
						$scope.postData.recaptchaResponse = token;
						$scope.submitFormPost();
					});
				});
			}
			else{
				$scope.submitFormPost();
			}
		}
	};

	$scope.submitFormPost = function () {
		$scope.messages = [];
		if(typeof naturaltestData.recaptcha !== 'undefined'){
			$scope.postData[naturaltestData.recaptcha.field] = $scope.postData.recaptchaResponse;
		}
		$http({
			method: 'POST',
			url: $scope.postUrl,
			data: $scope.postData,
			xsrfCookieName: secure_xsrf_name,
			xsrfHeaderName: 'X-' + secure_xsrf_name
		}).then(function (response) {
			if (response.data.success) {
				$scope.message = response.data.message;
				$scope.submited = true;
			} else {
				if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
					$scope.messages = response.data.errors;
				}
			}
		}).then(function () {
			$scope.loading = false;
		});
	};


	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};

	$scope.termsModal = function(){
		var template = 'naturaltest/modal.html';
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'naturaltestPreviewCtrl',
			//size: 'sm',
			resolve: {
				item: function(){
					//return true;
				}
			}
		});

//		modalInstance.result.then(function(result){
//
//		}, modalRejectHandler);
	};

	$scope.findAddress = function () {
		$scope.postData.address_id = null;
		if ($scope.findUrl !== '' && $scope.postData.address != '') {
			$scope.addressLoading = true;
			$scope.clearAddressSugggests();
			ajaxSearch.search($scope.findUrl, {address: $scope.postData.address}).then(function (response) {
				if (response.success) {
					$scope.addresses = response.items;
					if ($scope.addresses.length > 0) {
						$scope.showSuggest = true;
					} else {
						$scope.addresses = [];
					}
					$scope.addressLoading = false;
				}
			}, function (response) {
				$log.error(response);
			});
		} else {
			$scope.clearAddressSugggests();
		}
	};

	$scope.setAddress = function (address) {
		$scope.postData.address_id = address._source.adr_id;
		$scope.postData.address = address._source.adr_sudetinis_adresas;
		$scope.postData.house = address._source.adr_vieta;
		$scope.postData.appartment = address._source.adr_patalpos_numeris;
		$scope.clearAddressSugggests();
	};

	$scope.clearAddressSugggests = function () {
		$scope.showSuggest = false;
		$scope.addresses = [];
	};

	SessionService.init();

	$scope.$on('$destroy', function() {
	  SessionService.stop();
	});

}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

EwSiteApp.controller('naturaltestPreviewCtrl',['$scope', '$uibModalInstance', 'item', function($scope, $uibModalInstance, item){
	$scope.item = angular.copy(item);
	$scope.save = function(){
		$uibModalInstance.close($scope.item);
	};
	$scope.cancel = function(){
		for(var i in $scope.require){
			$scope.require[i] = false;
		}
		$uibModalInstance.dismiss();
	};
}]);

//EwSiteApp.directive('numbersOnly', function () {
//	return {
//		restrict: 'A',
//		scope: {
//			value: '=ngModel'
//		},
//		controller: function ($scope) {
//			$scope.$watch(function () {
//				return $scope.value;
//			}, function (newVal) {
//				if (typeof newVal !== 'undefined') {
//					$scope.value = newVal.replace(/[^0-9]/g, '');
//				}
//			});
//		}
//	};
//});

//EwSiteApp.directive('floatNumbers', function () {
//	return {
//		restrict: 'A',
//		scope: {
//			value: '=ngModel'
//		},
//		controller: function ($scope) {
//			$scope.$watch(function () {
//				return $scope.value;
//			}, function (newVal) {
//				if (typeof newVal !== 'undefined') {
//					$scope.value = newVal.replace(/,/, '.').replace(/[^0-9\.]/g, '');
//				}
//			});
//		}
//	};
//});


//EwSiteApp.directive('datepicker1', function () {
//	return {
//		restrict: 'A',
//		link: function (scope, element, attr) {
//			$(element).pikaday({
//				firstDay: 1,
//				format: 'YYYY-MM-DD',
////				defaultDate: (attr.value)?attr.value: new Date(),
//				setDefaultDate: true,
//				showDaysInNextAndPreviousMonths: true,
//				i18n: {
//					previousMonth: 'Praėjęs mėnesis',
//					nextMonth: 'Sekantis mėnesis',
//					months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
//					weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
//					weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
//				}
//			});
//			$(element).addClass('datepicker');
//		}
//	};
//});

EwSiteApp.directive('onlyLettersInput', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attr, ngModelCtrl) {
			function fromUser(text) {
				var transformedInput = text.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0430-\u044f ]/g, '');
				if (transformedInput !== text) {
					ngModelCtrl.$setViewValue(transformedInput);
					ngModelCtrl.$render();
				}
				return transformedInput;
			}
			ngModelCtrl.$parsers.push(fromUser);
		}
	};
});

EwSiteApp.controller('NaturaltestFormEditCtrl',['$scope', '$http', '$sce', function ($scope, $http, $sce) {
	$scope.uploads_count = 0;
	$scope.postUrl = naturaltestData.saveUrl;
	$scope.showFormInputFields = false;
	$scope.loading = false;
	$scope.submited = false;



	$scope.postData = {
		comment: '',
		files: []
	};

	$scope.formValid = function(){
		if(typeof(naturaltestData.requireFile)!=='undefined'){
			return ($scope.postData.files.length>0);
		}
		return true;
	};


	$scope.submitForm = function () {
		$scope.trySubmit = true;
		if ($scope.postUrl && $scope.postUrl !== '') {
			$scope.loading = true;
			if(typeof naturaltestData.recaptcha !== 'undefined'){
				grecaptcha.ready(function() {
					grecaptcha.execute(naturaltestData.recaptcha.siteKey, {action: 'submit'}).then(function(token){
						$scope.postData.recaptchaResponse = token;
						$scope.submitFormPost();
					});
				});
			}
			else{
				$scope.submitFormPost();
			}
		}
	};

	$scope.submitFormPost = function () {
		$scope.messages = [];
		if(typeof naturaltestData.recaptcha !== 'undefined'){
			$scope.postData[naturaltestData.recaptcha.field] = $scope.postData.recaptchaResponse;
		}
//		console.log($scope.postData)
		$http({
			method: 'POST',
			url: $scope.postUrl,
			data: $scope.postData,
			xsrfCookieName: secure_xsrf_name,
			xsrfHeaderName: 'X-' + secure_xsrf_name
		}).then(function (response) {
			if (response.data.success) {
				$scope.message = response.data.message;
				$scope.submited = true;
				location.href = naturaltestData.back_url;
			} else {
				if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
					$scope.messages = response.data.errors;
				}
			}
		}).then(function () {
			$scope.loading = false;
		});
	};


	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};



}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

EwSiteApp.controller('NaturaltestFormItemEditCtrl',['$scope', '$http', '$sce', function ($scope, $http, $sce) {
	$scope.uploads_count = 0;
	$scope.postUrl = naturaltestData.saveUrl;
	$scope.showFormInputFields = false;
	$scope.loading = false;
	$scope.submited = false;
	$scope.historyDataUrl = naturaltestData.historyDataUrl;
	$scope.attDataUrl = naturaltestData.attDataUrl;
	$scope.startingPageHistory = 0;
	$scope.startingPage = 0;
	$scope.reloadPage = false;
//	$scope.loading = false;
	$scope.item = {
		attachments: []
	};


	$scope.postData = {
		transformatory_nr: '',
		municipality_id: '',
		requested_date: '',
		files: []
	};

	$scope.formValid = function(){
		if(typeof(naturaltestData.requireFile)!=='undefined'){
			return ($scope.postData.files.length>0);
		}
		return true;
	};


	$scope.submitForm = function () {
		$scope.trySubmit = true;
		if ($scope.postUrl && $scope.postUrl !== '') {
			$scope.loading = true;
			if(typeof naturaltestData.recaptcha !== 'undefined'){
				grecaptcha.ready(function() {
					grecaptcha.execute(naturaltestData.recaptcha.siteKey, {action: 'submit'}).then(function(token){
						$scope.postData.recaptchaResponse = token;
						$scope.submitFormPost();
					});
				});
			}
			else{
				$scope.submitFormPost();
			}
		}
	};

	$scope.submitFormPost = function () {
		$scope.messages = [];
		if(typeof naturaltestData.recaptcha !== 'undefined'){
			$scope.postData[naturaltestData.recaptcha.field] = $scope.postData.recaptchaResponse;
		}
//		console.log($scope.postData)
		$http({
			method: 'POST',
			url: $scope.postUrl,
			data: $scope.postData,
			xsrfCookieName: secure_xsrf_name,
			xsrfHeaderName: 'X-' + secure_xsrf_name
		}).then(function (response) {
			if (response.data.success) {
				$scope.message = response.data.message;
				$scope.submited = true;
				location.href = naturaltestData.back_url;
			} else {
				if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
					$scope.messages = response.data.errors;
				}
			}
		}).then(function () {
			$scope.loading = false;
		});
	};


	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};



}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});